module.exports = __webpack_public_path__ + "static/img/loginBg3.823450f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginBg3.png
// module id = oqB3
// module chunks = 3